import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _InteractionTypes;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { List } from 'immutable';
import { jsx } from '@instructure/emotion';
import { Button } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { IconPlusLine } from '@instructure/ui-icons';
import { Grid } from '@instructure/ui-grid';
import { PresentationContent } from '@instructure/ui-a11y-content';
import { interactionTypeMetadata } from '../../../util/interactionTypeMetadata';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var InteractionTypes = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_InteractionTypes = /*#__PURE__*/function (_Component) {
  function InteractionTypes() {
    var _this2;
    _classCallCheck(this, InteractionTypes);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, InteractionTypes, [].concat(args));
    _defineProperty(_this2, "renderInteractionTypeButton", function (intType, i) {
      var onClick, Icon, name, title, automation;
      switch (intType.name) {
        case 'Stimulus':
          onClick = function onClick() {
            return _this2.props.addStimulus(false);
          };
          Icon = IconPlusLine;
          name = t('Stimulus');
          title = t('Add Stimulus');
          automation = 'sdk-interaction-button-stimulus';
          break;
        case 'Passage':
          onClick = function onClick() {
            return _this2.props.addStimulus(true);
          };
          Icon = IconPlusLine;
          name = t('Text Block');
          title = t('Add Text Block');
          automation = 'sdk-interaction-button-passage';
          break;
        default:
          {
            onClick = partial(_this2.props.addItem, intType);
            var metadata = interactionTypeMetadata(intType);
            Icon = metadata.icon;
            name = metadata.name;
            title = t('Add {name} Question', {
              name: name
            });
            automation = "sdk-interaction-button-".concat(intType.slug);
            break;
          }
      }
      return jsx(Button, {
        key: intType.slug,
        margin: "0 0 xx-small",
        onClick: onClick,
        size: "small",
        "data-automation": automation,
        display: "block",
        textAlign: "start"
      }, jsx(Grid, {
        colSpacing: "none",
        vAlign: "middle"
      }, jsx(Grid.Row, {
        key: "iconrow"
      }, jsx(Grid.Col, {
        width: "auto"
      }, jsx("div", {
        css: _this2.props.styles.iconWrapper
      }, jsx(Icon, {
        title: title
      }))), jsx(Grid.Col, null, jsx("div", {
        css: _this2.props.styles.textWrapper
      }, jsx(PresentationContent, null, jsx(Text, {
        color: "primary"
      }, name)))))));
    });
    _defineProperty(_this2, "renderInteractionTypeRows", function () {
      var buttons = [];
      var types = _this2.props.types;

      // The interaction types are in alphabetical order
      types.sortBy(function (intType) {
        return interactionTypeMetadata(intType).name;
      }).forEach(function (intType, i) {
        var button = _this2.renderInteractionTypeButton(intType, i);
        if (i % _this2.props.columns === 0) {
          buttons[Math.floor(i / _this2.props.columns)] = [];
        }
        buttons[Math.floor(i / _this2.props.columns)].push(jsx(Grid.Col, {
          width: 12 / _this2.props.columns,
          key: intType.slug
        }, button));
      });
      return buttons.map(function (gridCols, i) {
        var key = gridCols.map(function (gridCol) {
          return gridCol.key;
        }).join('-');
        return jsx(Grid.Row, {
          key: key
        }, gridCols);
      });
    });
    _defineProperty(_this2, "renderStimulusTypeButton", function () {
      if (_this2.props.allowStimulusCreation) {
        var dividerRow = jsx(Grid.Row, {
          key: "divider"
        }, jsx(Grid.Col, {
          key: "divider"
        }, jsx("div", {
          css: _this2.props.styles.stimulusDivider
        })));
        var stimulusRow = jsx(Grid.Row, {
          key: "stimulus"
        }, jsx(Grid.Col, {
          width: 12 / _this2.props.columns,
          key: "stimulus"
        }, _this2.renderInteractionTypeButton({
          name: 'Stimulus',
          slug: 'stimulus'
        })), jsx(Grid.Col, {
          width: 12 / _this2.props.columns,
          key: "passage"
        }, _this2.renderInteractionTypeButton({
          name: 'Passage',
          slug: 'passage'
        })));
        return [dividerRow, stimulusRow];
      }
    });
    return _this2;
  }
  _inherits(InteractionTypes, _Component);
  return _createClass(InteractionTypes, [{
    key: "render",
    value: function render() {
      return jsx(Grid, {
        rowSpacing: "none",
        colSpacing: "small",
        startAt: "medium"
      }, this.renderInteractionTypeRows(), this.renderStimulusTypeButton());
    }
  }]);
}(Component), _defineProperty(_InteractionTypes, "displayName", 'InteractionTypes'), _defineProperty(_InteractionTypes, "componentId", "Quizzes".concat(_InteractionTypes.displayName)), _defineProperty(_InteractionTypes, "propTypes", {
  columns: PropTypes.number.isRequired,
  addItem: PropTypes.func.isRequired,
  addStimulus: PropTypes.func.isRequired,
  allowStimulusCreation: PropTypes.bool,
  types: ImmutablePropTypes.list,
  styles: PropTypes.object
}), _defineProperty(_InteractionTypes, "defaultProps", {
  allowStimulusCreation: true,
  types: List()
}), _InteractionTypes)) || _class);
export default InteractionTypes;